import { render, staticRenderFns } from "./CampaignsPage.vue?vue&type=template&id=d4d81ef8&lang=pug&"
import script from "./CampaignsPage.vue?vue&type=script&lang=js&"
export * from "./CampaignsPage.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsPage.vue?vue&type=style&index=0&id=d4d81ef8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports